import isUrlHttp from 'is-url-http'

import { DEFAULT_INFORMATION } from 'utils/constants'

export interface AvatarImageProps {
	src?: string | null
	className?: string
	alt?: string
	defaultImage?: string
}

export function getUrlFromAvatarImage(src?: string | null, defaultImage = DEFAULT_INFORMATION.avatarImageUrl) {
	let url = src
	if (!url) {
		url = defaultImage ?? DEFAULT_INFORMATION.avatarImageUrl
	} else {
		if (!isUrlHttp(url) && url.indexOf('data:') === -1) {
			url = `${import.meta.env.VITE_MEDIA_URL}/${src}`
		}
	}

	return url
}

export function AvatarImage({ src, defaultImage, className, ...props }: AvatarImageProps) {
	return (
		<div className={`rounded-full bg-accent-surface overflow-hidden ${className || ''}`}>
			<img src={getUrlFromAvatarImage(src, defaultImage)} className="size-full object-cover" {...props} />
		</div>
	)
}
